import { axios } from '../../../axios'

export const getCustomers = (params = {}) => {
  return axios.get('/admin/customers', { params }).then(({ data }) => data)
}

export const transformIntoSeller = (id, params = {}) => {
  return axios.put(`/admin/customers/${id}/transform-into-seller`, params).then(({ data }) => data)
}
